module.exports = __webpack_public_path__ + "static/media/MathCATIcon.897c8459.svg";